/**
* DevExpress Dashboard (_specific-calc-window-definition.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export let sliceTableDimensions = { propertyName: 'dimensions', modelName: 'Dimensions', array: true };
